
import { IImportHistory } from '@/apis/masterDataAPI'
import { TIMETABLE_DATETIME } from '@/utils/constants'
import { formatDate } from '@/utils/timeUtils'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Options({
  name: 'ImportHistoryDialog',
  emits: ['update:modelValue'],
})
export default class ImportHistoryDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: Object, default: null }) readonly history!: IImportHistory | null

  readonly ERROR_PREVIEW_LINES = 2
  expandedErrorIds: number[] = []

  @Watch('modelValue')
  onVisibilityChange(val: boolean) {
    if (!val) this.expandedErrorIds = []
  }

  get errorLinesById(): Record<number, string[]> {
    const map: Record<number, string[]> = {}
    for (const detail of this.history?.details ?? []) {
      map[detail.id] = this.parseErrorInfo(detail.errorInfo)
    }
    return map
  }

  visibleErrorLines(id: number): string[] {
    const lines = this.errorLinesById[id] ?? []
    return this.expandedErrorIds.includes(id) ? lines : lines.slice(0, this.ERROR_PREVIEW_LINES)
  }

  toggleErrorInfo(id: number) {
    this.expandedErrorIds = this.expandedErrorIds.includes(id)
      ? this.expandedErrorIds.filter((i) => i !== id)
      : [...this.expandedErrorIds, id]
  }

  formatTime(dateStr?: string): string {
    return dateStr ? formatDate(dateStr, TIMETABLE_DATETIME.DATETIME_WITH_SECOND_FORMAT) : ''
  }

  countIds(ids?: string): number {
    return ids ? ids.split(',').filter(Boolean).length : 0
  }

  parseErrorInfo(errorInfo?: string): string[] {
    if (!errorInfo) return []
    try {
      const parsed = JSON.parse(errorInfo)
      if (Array.isArray(parsed)) {
        return parsed.map((e) =>
          typeof e === 'object' && e !== null
            ? Object.entries(e)
                .map(([k, v]) => `${k}: ${v}`)
                .join(', ')
            : String(e)
        )
      }
    } catch (e) {}
    return [errorInfo]
  }
}
